import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PageHeader } from '../../components/layout/page/PageHeader';
import { PageShell } from '../../components/layout/page/PageShell';
import { usePermissions } from '../../contexts/PermissionsContext';
import { getJobPosition, JobPosition } from '../../services/jobPositionsApi';
import { JobPositionAttributionsPanel } from './JobPositionAttributionsPanel';

export function JobPositionAttributionsPage() {
  const { jobPositionId = '' } = useParams();
  const { canWriteModule } = usePermissions();
  const canWrite = canWriteModule('people.job-positions');
  const [position, setPosition] = useState<JobPosition | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!jobPositionId) {
      setLoading(false);
      return;
    }

    void (async () => {
      setLoading(true);
      try {
        setPosition(await getJobPosition(jobPositionId));
      } catch {
        setPosition(null);
        toast.error('Falha ao carregar o cargo.');
      } finally {
        setLoading(false);
      }
    })();
  }, [jobPositionId]);

  return (
    <PageShell>
      <div>
        <Link to="/people/job-positions" className="erp-link-back">
          ← Voltar para cargos
        </Link>
        <PageHeader
          title={position ? `Atribuições — ${position.name}` : 'Atribuições do cargo'}
          description="Defina o que compete ao cargo em cada nível. Itens de orientação — não são avaliáveis."
          actions={(
            <Link to="/people/job-attribution-kinds" className="erp-btn-secondary text-sm">
              Tipos de atribuição
            </Link>
          )}
        />
      </div>

      {loading ? (
        <p className="text-secondary-500">Carregando...</p>
      ) : !position ? (
        <p className="text-secondary-500">Cargo não encontrado.</p>
      ) : (
        <section className="erp-card">
          <div className="erp-card-body">
            <JobPositionAttributionsPanel jobPositionId={position.id} canWrite={canWrite} />
          </div>
        </section>
      )}
    </PageShell>
  );
}
